import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

interface IRowProps {
  isInvalid?: boolean;
  isInactive?: boolean;
}

interface ICellNumberProps {
  isInvalid?: boolean;
}

interface IColorIconProps {
  color?: string;
}

export const Wrapper = styled.div`
  display: flex;
  max-width: 420px;
  width: 100%;
  min-width: 369px;
  align-items: center;
  flex-direction: column;
`;

export const Cell = styled.div`
  display: flex;
  font-size: 13px;
  letter-spacing: 0.3px;
  line-height: 20px;
  color: ${colors.grey8};
  overflow: hidden;
`;

export const HeaderCell = styled(Cell)`
  color: ${colors.grey5};
  padding: 5px 0;
  display: inline-block;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const CellNumber = styled(Cell)<ICellNumberProps>`
  justify-content: flex-end;

  ${({ isInvalid }) =>
    isInvalid &&
    css`
      color: ${colors.red1};
    `};
`;

export const HeaderNumber = styled(CellNumber)`
  color: ${colors.grey5};
  padding: 5px 0;
`;

export const CellIcon = styled(Cell)`
  align-items: center;

  ${({ onClick }) =>
    onClick &&
    css`
      cursor: pointer;
    `};
`;

export const TextTruncate = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ColorIcon = styled.div<IColorIconProps>`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border-radius: 1px;
  background-color: ${({ color }) => color || colors.grey4};
`;

export const GridRow = styled.div<IRowProps>`
  padding: 3px;
  display: grid;
  grid-template-columns:
    minmax(16px, 16px) 2fr minmax(70px, 70px) minmax(min-content, 1fr)
    minmax(16px, 16px);
  grid-gap: 10px;
  width: 100%;

  &:not(:first-child) {
    border-top: 1px solid ${colors.grey2};
  }

  ${({ isInactive }) =>
    isInactive &&
    css`
      ${CellNumber} {
        color: ${colors.grey5};
      }
    `};
`;
